// Assets store
export const Assets = new Map();
export const ASSETS_COUNT = 1;
